import React, { Component } from 'react';
import { StyleSheet, View, ScrollView } from 'react-native';
import PropTypes from 'prop-types';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

var _jsxFileName="/Users/yuanfu/Documents/react-native-x-carousel/src/Carousel.js";var NUM_OF_DUP=3;var approximatelyEqualTo=function approximatelyEqualTo(a,b){var epsilon=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0.01;return Math.abs(a-b)<epsilon;};var Carousel=function(_Component){inherits(Carousel,_Component);function Carousel(){var _getPrototypeOf2;var _this;classCallCheck(this,Carousel);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this=possibleConstructorReturn(this,(_getPrototypeOf2=getPrototypeOf(Carousel)).call.apply(_getPrototypeOf2,[this].concat(args)));_this.scrollView=React.createRef();_this.state={currentPage:1,childWidth:0};_this.isLooped=function(){var _this$props=_this.props,data=_this$props.data,loop=_this$props.loop;return loop&&data.length>1;};_this.setAutoPlay=function(start){if(start){_this.setAutoPlay(false);var _this$props2=_this.props,data=_this$props2.data,autoplayInterval=_this$props2.autoplayInterval;_this.autoplayTimeout=setTimeout(function(){var isLooped=_this.isLooped();var _this$state=_this.state,childWidth=_this$state.childWidth,currentPage=_this$state.currentPage;var isLastPage=data.length===currentPage;var scrollX;if(isLooped){var loopOffset=data.length>=NUM_OF_DUP?NUM_OF_DUP:data.length;scrollX=childWidth*(currentPage+loopOffset);}else{scrollX=isLastPage?0:childWidth*currentPage;}_this.scrollView.current.scrollTo({x:scrollX,animated:true});},autoplayInterval);}else{clearTimeout(_this.autoplayTimeout);}};_this.onScroll=function(_ref){var x=_ref.nativeEvent.contentOffset.x;_this.setAutoPlay(false);var _this$props3=_this.props,data=_this$props3.data,autoplay=_this$props3.autoplay;var _this$state2=_this.state,prevPage=_this$state2.currentPage,childWidth=_this$state2.childWidth;var isLooped=_this.isLooped();var loopOffset=0;if(isLooped){loopOffset=data.length>=NUM_OF_DUP?NUM_OF_DUP:data.length;}var rawCurrentPage=x/childWidth;var roundCurrentPage=Math.round(rawCurrentPage);var normalizedPage=roundCurrentPage-loopOffset;var currentPage=normalizedPage+1;if(normalizedPage<0){currentPage=data.length+normalizedPage+1;}else if(normalizedPage>=data.length){currentPage=normalizedPage%data.length+1;}var isScrollEnd=approximatelyEqualTo(rawCurrentPage,roundCurrentPage);if(isLooped&&isScrollEnd&&(normalizedPage<0||normalizedPage>=data.length)){_this.scrollView.current.scrollTo({x:(currentPage-1+loopOffset)*childWidth,animated:false});}if(isScrollEnd&&autoplay){_this.setAutoPlay(true);}if(currentPage!==prevPage){_this.setState({currentPage:currentPage});var onPage=_this.props.onPage;onPage({prev:prevPage,current:currentPage});}};_this.onContentSizeChange=function(contentWidth){var _this$props4=_this.props,data=_this$props4.data,autoplay=_this$props4.autoplay;var isLooped=_this.isLooped();var loopOffset=data.length>=NUM_OF_DUP?NUM_OF_DUP:data.length;var childrenNum=isLooped?data.length+loopOffset*2:data.length;_this.setState({childWidth:contentWidth/childrenNum},function(){if(isLooped){var childWidth=_this.state.childWidth;_this.scrollView.current.scrollTo({x:childWidth*loopOffset,animated:false});}if(autoplay){_this.setAutoPlay(true);}});};_this.renderItems=function(){var _this$props5=_this.props,data=_this$props5.data,renderItem=_this$props5.renderItem;var normalizedData=data;var isLooped=_this.isLooped();var loopOffset=0;if(isLooped){var frontDup=data.slice(-NUM_OF_DUP);var endDup=data.slice(0,NUM_OF_DUP);loopOffset=frontDup.length;normalizedData=frontDup.concat(data,endDup);}return normalizedData.map(function(item,index){var normalizedIndex=index-loopOffset;var renderIndex=normalizedIndex%data.length;renderIndex=renderIndex<0?data.length+renderIndex:renderIndex;var renderedItem=renderItem(item,renderIndex);var key=renderedItem.key;if(normalizedIndex<0){key=key+"-front-dup";}else if(normalizedIndex>=data.length){key=key+"-end-dup";}return React.createElement(React.Fragment,{key:key,__source:{fileName:_jsxFileName,lineNumber:176}},renderedItem);});};_this.renderPagination=function(){var _this$props6=_this.props,data=_this$props6.data,Pagination=_this$props6.pagination;var currentPage=_this.state.currentPage;var pagination=null;if(Pagination){pagination=React.createElement(Pagination,{currentPage:currentPage,total:data.length,__source:{fileName:_jsxFileName,lineNumber:193}});}return pagination;};_this.render=function(){var childWidth=_this.state.childWidth;return React.createElement(View,{__source:{fileName:_jsxFileName,lineNumber:208}},React.createElement(ScrollView,{ref:_this.scrollView,style:[styles.scrollView,{width:childWidth}],pagingEnabled:true,horizontal:true,showsHorizontalScrollIndicator:false,showsVerticalScrollIndicator:false,bounces:false,onScrollEndDrag:_this.onScrollEndDrag,scrollEventThrottle:16,onScroll:_this.onScroll,onContentSizeChange:_this.onContentSizeChange,__source:{fileName:_jsxFileName,lineNumber:209}},_this.renderItems()),_this.renderPagination());};return _this;}createClass(Carousel,[{key:"componentWillUnmount",value:function componentWillUnmount(){this.setAutoPlay(false);}}]);return Carousel;}(Component);var styles=StyleSheet.create({scrollView:{flexGrow:0}});Carousel.propTypes={renderItem:PropTypes.func.isRequired,data:PropTypes.arrayOf(PropTypes.shape({})),loop:PropTypes.bool,autoplay:PropTypes.bool,autoplayInterval:PropTypes.number,pagination:PropTypes.elementType,onPage:PropTypes.func};Carousel.defaultProps={data:[],loop:false,autoplay:false,autoplayInterval:2000,pagination:null,onPage:function onPage(){}};

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

var _jsxFileName$1="/Users/yuanfu/Documents/react-native-x-carousel/src/Pagination.js";var Pagination=function Pagination(props){var total=props.total,currentPage=props.currentPage,theme=props.theme;var opacities=theme==='dark'?[0.5,0.2]:[0.8,0.4];var renderDots=function renderDots(){var Dots=[];for(var i=0;i<total;i+=1){var isActive=currentPage===i+1;var additionalStyle={opacity:isActive?opacities[0]:opacities[1],marginLeft:i===0?0:8,backgroundColor:theme==='dark'?'#000':'#fff'};Dots.push(React.createElement(View,{key:"pagination-dot-"+i,style:[styles$1.dot,additionalStyle],__source:{fileName:_jsxFileName$1,lineNumber:29}}));}return Dots;};return React.createElement(View,{style:styles$1.container,__source:{fileName:_jsxFileName$1,lineNumber:42}},renderDots());};var styles$1=StyleSheet.create({container:{position:'absolute',bottom:'5%',left:0,right:0,flexDirection:'row',alignItems:'center',justifyContent:'center'},dot:{width:6,height:6,borderRadius:3}});Pagination.propTypes={currentPage:PropTypes.number.isRequired,total:PropTypes.number.isRequired,theme:PropTypes.oneOf(['dark','light'])};Pagination.defaultProps={theme:'dark'};var PaginationLight=function PaginationLight(props){return React.createElement(Pagination,_extends_1({},props,{theme:"light",__source:{fileName:_jsxFileName$1,lineNumber:78}}));};

export default Carousel;
export { Pagination, PaginationLight };
